exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".an-user-name{\r\n    font-family: 'Arial Regular';\r\n    font-size: 15px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/app/shared/header/header.component.css
// module id = ../../../../../src/app/shared/header/header.component.css
// module chunks = main